module.exports = __webpack_public_path__ + "static/media/alpha_20.2a31730c.png";